import React, { useEffect } from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material';
import Navbar from './customer/components/Navbar/Navbar';
import Footer from './customer/pages/Home/Footer';
import customeTheme from './Theme/customeTheme';
import Home from './customer/pages/Home/Home';
import Product from './customer/pages/Product/Product';
import ProductDetails from './customer/pages/Page Details/ProductDetails';
import Review from './customer/pages/Review/Review';
import Cart from './customer/pages/Cart/Cart';
import Checkout from './customer/pages/Checkout/Checkout';
import Account from './customer/pages/Account/Account';
import { Route, Routes, useLocation } from 'react-router-dom';
import BecomeSeller from './customer/pages/Become Seller/BecomeSeller';
import SellerDashboard from './seller/pages/SellerDashbord/sellerDashboard';
import AdminDashboard from './admin/Pages/Dashboard/AdminDashboard';
import { useAppDispatch, useAppSelector } from './State/Store';
import { fetchSellerProfile } from './State/seller/SellerSlice';
import Auth from './customer/pages/Auth/Auth';
import { fetchUserProfile } from './State/AuthSlice';
import Wishlist from './customer/Wishlist/Wishlist';
import { createHomeCategories } from './State/customer/customerSlice';
import { homeCategories } from './data/HomeCategories';
import AdminLoginForm from './admin/Pages/Auth/AdminLoginForm';
import OfferLandingPage from './customer/pages/Offer/OfferLandingPage';


function App() {
  const dispatch = useAppDispatch();
  const location = useLocation();

  // Destructure auth to easily check the user object and role
  const { auth } = useAppSelector(store => store);
  const user = auth.user;

  const jwt = auth.jwt || localStorage.getItem("jwt");

  // 1. Core initialization on app start
  useEffect(() => {
    const formattedCategories = homeCategories.map((category, index) => ({
      ...category,
      id: index + 1,
    }));
    dispatch(createHomeCategories(formattedCategories));
  }, [dispatch]);

  // 2. Fetch/sync user profile info whenever the token exists
  useEffect(() => {
    if (jwt) {
      dispatch(fetchUserProfile({ jwt }));
    }
  }, [jwt, dispatch]);

  // 3. ONLY fetch seller profile if the authenticated user has a Seller role
  useEffect(() => {
    const userRole = user?.role as string;

    if (jwt && user && (userRole === "ROLE_SELLER" || userRole === "Role_Seller")) {
      dispatch(fetchSellerProfile(jwt));
    }
  }, [jwt, user, dispatch]);

  // Isolate your view filters cleanly
  const isDashboardView = location.pathname.startsWith("/seller") || location.pathname.startsWith("/admin");

  return (
    <ThemeProvider theme={customeTheme}>
      <div className="flex flex-col min-h-screen">
        {/* Only mount standard Nav features outside management tools */}
        {!isDashboardView && <Navbar />}

        {/* Main content wrapper grows to push footer to bottom */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Auth />} />

            <Route path="/products" element={<Product />} />
            <Route path="/products/:category" element={<Product />} />
            <Route path="/offer/:id" element={<OfferLandingPage />} />

            <Route path="/reviews/:productId" element={<Review />} />
            <Route path="/product-details/:categoryId/:name/:productId" element={<ProductDetails />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/account/*" element={<Account />} />
            <Route path="/become-seller" element={<BecomeSeller />} />
            <Route path="/admin/login" element={<AdminLoginForm />} />

            <Route path="/seller/*" element={<SellerDashboard />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
        </main>

        {/* Only mount standard Footer outside management tools */}
        {!isDashboardView && <Footer />}
      </div>
    </ThemeProvider>
  );
}

export default App;